module.exports = __webpack_public_path__ + "img/chinesecompany166.b37e7ab1.png";